class ProductRecommendations extends HTMLElement {

  #intersectionObserver = new IntersectionObserver(

    (entries, observer) => {

      if (!entries[0]?.isIntersecting) return;



      observer.disconnect();

      this.#loadRecommendations();

    },

    { rootMargin: '0px 0px 400px 0px' }

  );

  #mutationObserver = new MutationObserver((mutations) => {

    for (const mutation of mutations) {

      if (mutation.target !== this || mutation.type !== 'attributes') continue;

      if (

        mutation.attributeName === 'data-recommendations-performed' &&

        this.dataset.recommendationsPerformed === 'true'

      )

      continue;

      this.#loadRecommendations();

      break;

    }

  });

  #cachedRecommendations = {};

  #activeFetch = null;

  connectedCallback() {

    this.#intersectionObserver.observe(this);

    this.#mutationObserver.observe(this, { attributes: true });

  }

  #loadRecommendations() {

    const { productId, recommendationsPerformed, sectionId, intent } = this.dataset;

    const id = this.id;

    if (!productId || !id) {

      throw new Error('Product ID and an ID attribute are required');

    }

    if (recommendationsPerformed === 'true') {

      return;

    }

    this.#fetchCachedRecommendations(productId, sectionId, intent)

      .then((result) => {

        if (!result.success) {

          if (!Shopify.designMode) {

            this.#handleError(new Error(`Server returned ${result.status}`));

          }

          return;

        }



        const html = document.createElement('div');

        html.innerHTML = result.data || '';

        const recommendations = html.querySelector(`product-recommendations[id="${id}"]`);



        if (recommendations?.innerHTML && recommendations.innerHTML.trim().length) {

          this.dataset.recommendationsPerformed = 'true';

          this.innerHTML = recommendations.innerHTML;

        } else {

          this.#handleError(new Error('No recommendations available'));

        }

      })

      .catch((e) => {

        this.#handleError(e);

      });

  }

  async #fetchCachedRecommendations(productId, sectionId, intent) {

    const url = `${this.dataset.url}&product_id=${productId}&section_id=${sectionId}&intent=${intent}`;



    const cachedResponse = this.#cachedRecommendations[url];

    if (cachedResponse) {

      return { success: true, data: cachedResponse };

    }



    this.#activeFetch?.abort();

    this.#activeFetch = new AbortController();



    try {

      const response = await fetch(url, { signal: this.#activeFetch.signal });

      if (!response.ok) {

        return { success: false, status: response.status };

      }



      const text = await response.text();

      this.#cachedRecommendations[url] = text;

      return { success: true, data: text };

    } finally {

      this.#activeFetch = null;

    }

  }

  #handleError(error) {

    console.error('Product recommendations error:', error);

    this.classList.add('hidden');

    this.dataset.error = 'Error loading product recommendations';

  }

}



if (!customElements.get('product-recommendations')) {

  customElements.define('product-recommendations', ProductRecommendations);

}

